const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedCasinoTag: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const casinotag = (state = initialState, action) => {
	switch (action.type) {
		case 'CASINOTAG_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'CASINOTAG_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'CASINOTAG_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'CASINOTAG_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'CASINOTAG_GET_CURRENT':
			return {
				...state,
				selectedCasinoTag: action.selectedCasinoTag,
			}
		case 'CASINOTAG_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default casinotag
